import { ThemeUICSSObject } from '@apia/theme';
import { panel } from './panel';

export const dashboards: ThemeUICSSObject = { panel };
